import React from 'react';
import { Mail, MessageCircle, Clock } from 'lucide-react';

const contacts = [
  {
    Icon: MessageCircle,
    label: 'Telegram',
    value: '@freeapp',
    hint: 'Отвечаем в течение часа',
    href: 'https://t.me/freeapp',
  },
  {
    Icon: Mail,
    label: 'Email',
    value: 'support@freeapp.ru',
    hint: 'Для официальных запросов',
    href: 'mailto:support@freeapp.ru',
  },
  {
    Icon: Clock,
    label: 'Время работы',
    value: 'Ежедневно 10:00 – 22:00',
    hint: 'МСК (UTC+3)',
    href: null,
  },
];

const ContactsPage = () => (
  <div className="min-h-screen overflow-x-hidden bg-background px-4 py-6 text-foreground sm:py-8">
    <div className="mx-auto max-w-3xl">

      <div className="mb-8">
        <h1 className="text-3xl font-semibold sm:text-5xl">Контакты</h1>
        <p className="mt-3 text-foreground/40">Свяжитесь с нами любым удобным способом</p>
      </div>

      <div className="grid gap-3 sm:grid-cols-3">
        {contacts.map(({ Icon, label, value, hint, href }) => {
          const inner = (
            <div className="rounded-[24px] border border-foreground/10 bg-card p-5 transition-colors hover:border-foreground/[0.18]">
              <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-2xl border border-red-500/20 bg-red-600/15">
                <Icon className="h-5 w-5 text-red-600 dark:text-red-400" />
              </div>
              <p className="text-xs text-foreground/35 mb-1">{label}</p>
              <p className="font-semibold text-foreground">{value}</p>
              <p className="mt-1 text-xs text-foreground/35">{hint}</p>
            </div>
          );
          return href
            ? <a key={label} href={href} target="_blank" rel="noreferrer">{inner}</a>
            : <div key={label}>{inner}</div>;
        })}
      </div>

    </div>
  </div>
);

export default ContactsPage;
